import { Theme } from '@mui/material';

import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const footerWrapperStyling: AbgSxProps = (theme: Theme) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: paletteBase.white100,
  padding: '16px 56px',
  marginTop: '14px',
  position: 'sticky',
  bottom: '0',
  zIndex: 2,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '16px 32px',
  },
  [theme.breakpoints.down(480)]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
});

export const actionContainerStyling =
  (isModificationFlow: boolean, isUpgradeFlow?: boolean): AbgSxProps =>
  (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      width: '100%',
    },
    ...(isModificationFlow && {
      [theme.breakpoints.down(480)]: {
        flexDirection: isUpgradeFlow ? 'row' : 'column',
        width: '100%',
        gap: '8px',
      },
    }),
  });

export const buttonsContainerStyling =
  (isModificationFlow: boolean): AbgSxProps =>
  (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'row',
    order: {
      xs: 3,
      sm: 3,
    },
    gap: {
      xs: '12px',
      sm: 0,
    },
    alignItems: 'center',
    ...(isModificationFlow && {
      [theme.breakpoints.down(480)]: {
        flexDirection: 'column',
        gap: '8px',
      },
    }),
  });

export const actionButtonStyling: AbgSxProps = {
  marginLeft: { xs: 'initial', sm: '16px' },
  whiteSpace: 'normal',
  minWidth: { xs: 'fit-content', sm: 'auto' },
  flex: { xs: 1, sm: 'initial' },
};

export const checkoutMobileWrapperStyling: AbgSxProps = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  backgroundColor: paletteBase.white100,
  marginTop: '24px',
  padding: '12px 24px',
  boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.06)',
};

export const checkoutMobileActionContainer: AbgSxProps = {
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
};

export const checkoutMobileActionButtonStyling: AbgSxProps = {
  flex: 'none',
  marginLeft: 0,
  minWidth: 'auto',
  whiteSpace: 'nowrap',
};

export const loaderStyling: AbgSxProps = {
  marginBottom: { xs: '8px 0' },
};

export const tncContainerStyling: AbgSxProps = {
  textAlign: 'left',
  flexGrow: 1,
};

export const mobileDisclaimerBelowCtaStyling: AbgSxProps = {
  color: '#736D6D',
  fontSize: '10px',
  fontWeight: 500,
  width: '100%',
  textAlign: 'center',
  marginTop: '8px',
};
